// import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import flexibility from 'flexibility';
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import isMobile from './modules/common/is-mobile.js';
import './modules/common/smoothScroll.js';
import './modules/common/lazyload.js';
import './modules/common/userAgent.js';
// import './modules/common/sp-menu.js';
// import './modules/common/datepicker.js';
// import './modules/common/tablefix.js';
import './modules/common/picturefill.min.js';

flexibility(document.documentElement);//flexboxのie対応
objectFitImages();//object-fitのie対応
svg4everybody();//svgをieで表示
document.createElement( "picture" );//pictureをie対応

//電話番号スマホのみ掛ける
$("a[href*='tel']").on("click", function(e){
  if(!isMobile(768)){
    return false
  }
});

//アコーディオン
$(document).ready(function(){
  $(".top-heed-accordion__text").hide();
  $(".top-heed-accordion__title").click(function(){
    $(this).toggleClass("active").next().slideToggle("show");
  });
});

$('.top-step-item').on({
  'touchstart mouseenter': function touchstartMouseenter() {
    if(!isMobile(768)){
      var num = $(this).index() + 1;
      // $('.top-step-item').removeClass($("[class*='is-step-']"));
      $('.top-step-item').removeClass('is-active');
      $(this).addClass('is-active');
      setTimeout(function() {
        $('.top-step').removeClass(function(index, className) {
          return (className.match(/\bis-step-\S+/g) || []).join(' ');
        });
        $('.top-step').addClass('is-step-' + num);
      }, 300);
    }
  },
  'touchend mouseleave': function touchendMouseleave() {
    if(!isMobile(768)){
    }
  }
});

$('.top-step-number').on("click", function(e){
  if(isMobile(768)){
    $('.top-step-item').removeClass('is-active');
    $(this).closest('.top-step-item').addClass('is-active');
  }
})
// const hoge = val => val + 1;
// console.log(hoge(1));
